import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { HeadlineSize } from '@/enums';
import userAgent from '@/services/userAgent.service';
import useBreakpoints from '@/core/responsive/breakpoints/breakpoint.mixin';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockFullWidthImageWithText',
  props: {
    headline: null,
    bodyText: null,
    mobileBodyColor: { default: '#000000' },
    buttonText: null,
    buttonColor: { default: null },
    useFilledButton: { type: Boolean },
    link: null,
    isH1Element: { type: Boolean },
    headlineColor: { default: '#000000' },
    headlineSize: { default: 0 },
    videoUrl: { default: '' },
    mobileVideoUrl: { default: '' },
    videoAutoplay: { type: Boolean },
    backgroundColor: { default: null },
    image: { default: () => ({} as Vertica.LouisPoulsen.Application.Content.Blocks.ImageViewModel) },
    mobileImage: { default: () => ({} as Vertica.LouisPoulsen.Application.Content.Blocks.ImageViewModel) }
  },
  setup(__props: any) {

const props = __props as { headline?: string, bodyText?: string, mobileBodyColor: string, buttonText?: string, buttonColor: string | null, useFilledButton?: boolean, link?: LinkViewObject, isH1Element?: boolean, headlineColor: string, headlineSize: Vertica.LouisPoulsen.Application.Content.Blocks.PropertyLists.Enums.HeadlineSize, videoUrl: string, mobileVideoUrl: string, videoAutoplay?: boolean, backgroundColor: string | null, image: Vertica.LouisPoulsen.Application.Content.Blocks.ImageViewModel, mobileImage: Vertica.LouisPoulsen.Application.Content.Blocks.ImageViewModel }

const isInEditMode = computed<boolean>(() => store.getters['app/isInEditMode']);



const runAnimations = ref<boolean>(userAgent.isPrerender);
const showPlayButton = ref<boolean>(false);

const breakpoints = useBreakpoints();
const videoPlayerUrl = computed<string>(() => {
    return breakpoints.value.small ? (props.mobileVideoUrl || props.videoUrl) : props.videoUrl;
});
const isVideo = computed<boolean>(() => videoPlayerUrl.value !== '' && videoPlayerUrl.value !== undefined);
const hasHeadline = computed<boolean>(() => props.headline !== '');

function initAnimations(): void {
    runAnimations.value = true;
}

if (!props.videoAutoplay) {
    showPlayButton.value = true;
}

const videoElement = ref(null);

function playVideo() {
    showPlayButton.value = false;
    const video = videoElement.value as HTMLVideoElement;
    video.play();
}

function showVideo() {
    if (!props.videoAutoplay) {
        return;
    }
    const video = videoElement.value as HTMLVideoElement;
    const promise = video.play();
    if (promise !== undefined) {
        promise.then().catch(() => {
            console.log('Play button not supported');
            showPlayButton.value = true;
        });
    }
}

function goToLink() {
    if (!showPlayButton.value && props.link.url) {
        window.open(props.link.url, props.link.openInNewWindow ? '_blank' : '_parent');
    }
}

function getTextSize(defaultClass: string) {
    switch (props.headlineSize) {
    case HeadlineSize.Caption:
        return 'u-text-caption-m lg:u-text-caption';

    case HeadlineSize.H3:
        return 'u-text-h3';

    case HeadlineSize.H2:
        return 'u-text-h2';

    case HeadlineSize.H1:
        return 'u-text-h1';

    case HeadlineSize.Hero:
        return 'u-text-hero';

    default:
        return defaultClass;
    }
}

return { __sfc: true,isInEditMode, props, runAnimations, showPlayButton, breakpoints, videoPlayerUrl, isVideo, hasHeadline, initAnimations, videoElement, playVideo, showVideo, goToLink, getTextSize }
}

})